/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model from "@ember-data/model";
import Store from "@ember-data/store";
import { action } from "@ember/object";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import MedicModel from "core/models/medic";
import Patient from "core/models/patient";
import { EmberChangeset } from "ember-changeset";
let PlanificationResponsibleDropdownComponent = (_class = class PlanificationResponsibleDropdownComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
  }
  get changeset() {
    return this.args.changeset;
  }
  get propertyName() {
    return this.args.propertyName;
  }
  get patient() {
    return this.args.patient;
  }
  get possibleResponsibles() {
    const medics = this.store.peekAll("medic");
    const responsibles = medics.map(creator => ({
      id: this._computeCustomUuid(creator),
      name: creator.fullName
    }));
    responsibles.push({
      id: this._computeCustomUuid(undefined),
      name: "Autre"
    });
    return responsibles;
  }
  get selectedResponsible() {
    const responsible = this.changeset.get(this.propertyName);
    return this._computeCustomUuid(responsible?.content || responsible);
  }
  onChange(customUuid) {
    this.changeset.set(this.propertyName, this._retrieveResponsible(customUuid));
  }
  _computeCustomUuid(creator) {
    if (creator) {
      return `${(creator?.constructor).modelName}-${creator?.id}`;
    }
    return "undefined-undefined";
  }
  _retrieveResponsible(customUuid) {
    const creatorInfos = customUuid.split("-");
    const creator = this.store.peekRecord(creatorInfos[0], creatorInfos[1]);
    return creator;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _class);
export { PlanificationResponsibleDropdownComponent as default };